import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import "./style.css";
export default function DNALoader({ style, className }) {
  return /* @__PURE__ */ jsxs("div", { className: classNames("dna-loader", className), style, children: [
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" }),
    /* @__PURE__ */ jsx("div", { className: "nucleobase" })
  ] });
}
